import { createI18n } from "vue-i18n";
import enLocale from "./lang/en.json";
import viLocale from "./lang/vi.json";

const language = localStorage.getItem("language") || "vi";
const messages = {
  en: enLocale,
  vi: viLocale,
};
const setDateTimeFormats = {
  short: {
    year: "numeric",
    month: "short",
    day: "numeric",
  },
  long: {
    year: "numeric",
    month: "long",
    day: "numeric",
    weekday: "long",
    hour: "numeric",
    minute: "numeric",
  },
};

const dateTimeFormats = {
  en: setDateTimeFormats,
  es: setDateTimeFormats,
  de: setDateTimeFormats,
  "en-GB": setDateTimeFormats,
};

export default createI18n({
  locale: language,
  //locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: "vi",
  globalInjection: true,
  messages,
  dateTimeFormats,
});
